import { useSuspenseQuery } from '@tanstack/react-query'
import { createFileRoute, useRouter } from '@tanstack/react-router'
import { useCallback, useMemo } from 'react'
import PreviewBusDetail from '@/components/my-booking/modals/PreviewBusDetail'
import {
  getBookingQueryOptions,
  getBookingTransportationQueryOptions,
} from '@/queries/query'

export const Route = createFileRoute(
  '/my-booking/$id/view/$transportationId/amend',
)({
  component: RouteComponent,
})

function RouteComponent() {
  const router = useRouter()
  const transportationId = Route.useParams({
    select: (s) => s.transportationId,
  })
  const {
    data: {
      data: { booked_transportation },
    },
  } = useSuspenseQuery(getBookingTransportationQueryOptions(transportationId))

  const bookingId = Route.useParams({
    select: (s) => s.id,
  })

  const {
    data: {
      data: { booking },
    },
  } = useSuspenseQuery(getBookingQueryOptions(bookingId))

  const transportation = useMemo(() => {
    if (!booking.difference_attributes?.buses?.length)
      return booked_transportation
    return {
      ...booked_transportation,
      _difference: booking.difference_attributes.buses.find(
        (b) => b.transportation_id === booked_transportation.id,
      ),
    }
  }, [booked_transportation, booking.difference_attributes])

  const onClose = useCallback(() => {
    return router.history.back()
  }, [router.history])

  return <PreviewBusDetail isOpen bus={transportation} onClose={onClose} />
}
